module.exports = __webpack_public_path__ + "img/step09_a_basket_power_connect_left_right_brackets_Juliol2023.e2f37154.png";